import constants from '../../constants/app-constants';

const initialState = {
  requests: null
};

const RewardPool = (state = initialState , action) => {
  switch(action.type){
  case constants.admin.REWARD_POOL_NEW : return {...state , requests : action.payload};

  case constants.admin.REWARD_POOL_GET: {
    return {...state, rewardPool: action.payload};
  }

  case constants.admin.REWARD_POOL_EDIT: {
    return {...state, rewardPoolEdit: action.payload};
  }

  default: return state;
  }
};

export default RewardPool;